import request from '@/utils/request';

/**
 *  快手小说管理
 */
export function KsNovalManagement () {
    return {
        /** 平台管理 */
        //列表
        ApiPlatformList: params => {
            return request ({
                url: '/admin/ksnovel/platform/index',
                method: 'get',
                params,
            });
        },
        //详情
        ApiPlatformInfo: params => {
            return request ({
                url: '/admin/ksnovel/platform/info',
                method: 'get',
                params,
            });
        },
        //删除
        ApiPlatformDel: params => {
            return request ({
                url: '/admin/ksnovel/platform/del',
                method: 'get',
                params,
            });
        },
        //编辑
        ApiPlatformEdit: params => {
            return request ({
                url: '/admin/ksnovel/platform/edit',
                method: 'post',
                data: params,
            });
        },
        //更新开启状态
        ApiPlatformUpdateStatus: params => {
            return request ({
                url: '/admin/ksnovel/platform/editstatus',
                method: 'post',
                data: params,
            });
        },


        /** 快手小说管理 */
        //列表
        ApiNovelList: params => {
            return request ({
                url: '/admin/ksnovel/novel/index',
                method: 'get',
                params,
            });
        },
        //详情
        ApiNovelInfo: params => {
            return request ({
                url: '/admin/ksnovel/novel/info',
                method: 'get',
                params,
            });
        },
        //删除
        ApiNovelDel: params => {
            return request ({
                url: '/admin/ksnovel/novel/del',
                method: 'get',
                params,
            });
        },
        //编辑
        ApiNovelEdit: params => {
            return request ({
                url: '/admin/ksnovel/novel/edit',
                method: 'post',
                data: params,
            });
        },
        //提审
        ApiNovelSubmit: params => {
            return request ({
                url: '/admin/ksnovel/novel/submit',
                method: 'get',
                params,
            });
        },

        /** 分类 / 题材管理 */
        //分类+题材下拉框-树形
        ApiCategorySelect: params => {
            return request ({
                url: '/admin/ksnovel/category/select',
                method: 'get',
                params,
            });
        },
        //题材下拉框-树形
        ApiCategoryThemesSelect: params => {
            return request ({
                url: '/admin/ksnovel/category/themes',
                method: 'get',
                params,
            });
        },

        /** 快手小说-章节管理 */
        //列表
        ApiChapterList: params => {
            return request ({
                url: '/admin/ksnovel/chapter/index',
                method: 'get',
                params,
            });
        },
        //详情
        ApiChapterInfo: params => {
            return request ({
                url: '/admin/ksnovel/chapter/info',
                method: 'get',
                params,
            });
        },
        //删除
        ApiChapterDel: params => {
            return request ({
                url: '/admin/ksnovel/chapter/del',
                method: 'get',
                params,
            });
        },
        //编辑
        ApiChapterEdit: params => {
            return request ({
                url: '/admin/ksnovel/chapter/edit',
                method: 'post',
                data: params,
            });
        },
        //批量上传-文件解析
        ApiChapterBatchImport: params => {
            return request ({
                url: '/admin/ksnovel/chapter/import',
                method: 'post',
                data: params,
            });
        },
        //批量上传-保存
        ApiChapterBatchImportSave: params => {
            return request ({
                url: '/admin/ksnovel/chapter/importsave',
                method: 'post',
                data: params,
            });
        },

        /** 快手小说-订单列表 */
        //列表
        ApiOrderList: params => {
            return request ({
                url: '/admin/ksnovel/order/index',
                method: 'get',
                params,
            });
        },
        //删除
        ApiOrderDel: params => {
            return request ({
                url: '/admin/ksnovel/order/del',
                method: 'get',
                params,
            });
        },
        //导出
         ApiexportDownText: params => {
            return request ({
                url: '/admin/ksnovel/novel/generatetxt',
                method: 'get',
                params,
                isBolb: true
            });
        },
         //导出
         Apiexport: params => {
            return request ({
                url: '/admin/ksnovel/novel/export',
                method: 'get',
                params,
            });
        },
          //ai封面
          ApiAicover: params => {
            return request ({
                url: `/admin/ksnovel/novel/aicover?id=${params}`,
                method: 'get',
                
            });
        },
    };
}
